import { PricingPage } from 'routes/Pricing'

export default function WebsitePricing() {
  return <PricingPage />
}
